import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import { ChannelLeadAction } from '_models/redux/channel-lead/action';
import { cleanChannelLead } from '_models/redux/channel-lead/clean';
import { CreateLead } from '_models/redux/create_lead/action';
import { cleanCreateLead } from '_models/redux/create_lead/clean';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ModalGeneric from './PopopGeneric';

const HelpdeskHeader = (props) => {
  const { channelCreatedLead, CreateLead, createLeadObj, cleanCreateLead, cleanChannelLead } =
    props || {};
  const { payload } = channelCreatedLead || {};
  const { channels } = payload || {};

  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownOptionsChannels, setDropdownOptionsChannels] = useState('');
  const [selectChannel, setSelectChannel] = useState('');

  useEffect(() => {
    if (modalOpen) {
      props.ChannelLeadAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  useEffect(() => {
    setDropdownOptionsChannels(channels);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelCreatedLead]);

  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <Grid container direction={'row'}>
          <Grid item size={{ xs: 6 }} textAlign={'start'}>
            <h3>Tickets pendientes</h3>
          </Grid>
          <Grid item size={{ xs: 6 }} textAlign={'end'}>
            <button
              className='right openModalBtn'
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <AddIcon className='svg' />
              Nuevo Ticket
            </button>

            {modalOpen && (
              <ModalGeneric
                cleanChannelLead={cleanChannelLead}
                cleanCreateLead={cleanCreateLead}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                createLeadObj={createLeadObj}
                selectChannel={selectChannel}
                setSelectChannel={setSelectChannel}
                CreateLead={CreateLead}
                setDropdownOptionsChannels={setDropdownOptionsChannels}
                dropdownOptionsChannels={dropdownOptionsChannels}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

// export default Modal;
const mapStateToProps = (state) => ({
  channelCreatedLead: state.channelCreatedLead,
  createLeadObj: state.createLeadObj,
});
const mapDispatchToProps = {
  ChannelLeadAction,
  CreateLead,
  cleanCreateLead,
  cleanChannelLead,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskHeader);
